module.exports = __webpack_public_path__ + "img/userGuide.3751d1c8.png";